import React from 'react';
import PropTypes from 'prop-types';

import { useUserState } from 'contexts/auth-context';
import t from 'utils/translateFunc';

import {
  BtnPurpleTransparent32,
  BtnGreen32
} from 'components/common/Elements/Elements';

import classes from './BodyModalTestUser.module.scss';

const BodyModalTestUser = ({ onCancel, onClickOk }) => {
  const language = useUserState().user.language;

  return (
    <div className={classes.bodyModalTestUser}>
      <div className={classes.infoBox}>
        <div>
          <p className={classes.textTop}>
            <span className={classes.bold}>
              {t('statusTestUser', 'TEXT_ACCESS_TOP_ONE', language)}
            </span>
            &nbsp;
            {t('statusTestUser', 'TEXT_ACCESS_TOP_TWO', language)}&nbsp;
            <span className={classes.bold}>
              {t('statusTestUser', 'TEXT_ACCESS_TOP_THREE', language)}
            </span>
          </p>
          <p>{t('statusTestUser', 'TEXT_ACCESS_BOTTOM', language)}</p>
        </div>
        <div className={classes.btnBox}>
          <BtnPurpleTransparent32
            onClick={onCancel}
            textButton={t('statusTestUser', 'CANCEL', language)}
          />
          <BtnGreen32
            onClick={onClickOk}
            textButton={t('statusTestUser', 'SUBSCRIBE', language)}
            className={classes.subscribeBtn}
          />
        </div>
      </div>
    </div>
  );
};

BodyModalTestUser.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onClickOk: PropTypes.func.isRequired
};

export default BodyModalTestUser;
